import api from './api';

export const getCostoAmministrazione = async (cantiereId) => {
  const res = await api.get(`budget/costi-amministrazione/${cantiereId}`);

  return res.data;
};

export const saveCostoAmministrazione = async (cantiereId, dati) => {

  const res = await api.post(`budget/costi-amministrazione/${cantiereId}`, dati);
  return res.data;
};
